import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { useCategory } from '@vsf-enterprise/commercetools';
export var PAGES_WITH_NO_SLUG = ['PageProductInformationsListingPage'];
export var getGraphqlPagePrefix = function getGraphqlPagePrefix(contentType, locale) {
  switch (contentType) {
    case 'PageRecipeList':
      return 'recipes';
    case 'PageGenericCategory':
      return 'category';
    case 'PageRecipe':
      return 'recipe';
    case 'PageAdvice':
      return 'page';
    case 'PageAdviceListing':
      return 'pages';
    case 'PageProductInformationsListingPage':
      return '';
    case 'PageProductListingPage':
      return 'products';
    case 'PageBasic':
      return 'content';
    case 'PageAllProduct':
      return '';
    case 'PageProduct':
      return locale === 'fr' ? 'info/fiche-technique' : 'product';
    case 'PageProductInformations':
      return locale === 'fr' ? 'info/fiche-technique' : 'guide';
    default:
      return false;
  }
};
export default function (internalLinkObj) {
  var _internalLinkObj$sys;
  var _useI18nLocale = useI18nLocale(),
    isDefaultLocale = _useI18nLocale.isDefaultLocale,
    getCurrentLocale = _useI18nLocale.getCurrentLocale;
  var contentType = internalLinkObj === null || internalLinkObj === void 0 ? void 0 : internalLinkObj.__typename;
  var currentLocale = computed(function () {
    var _getCurrentLocale;
    return (_getCurrentLocale = getCurrentLocale()) === null || _getCurrentLocale === void 0 ? void 0 : _getCurrentLocale.code.toLowerCase();
  });
  var categoryId = computed(function () {
    return internalLinkObj === null || internalLinkObj === void 0 ? void 0 : internalLinkObj.category;
  });
  var _computed$value = computed(function () {
      return categoryId.value ? useCategory("getCategoryById-".concat(categoryId.value)) : {
        categories: ref([]),
        search: function search() {}
      };
    }).value,
    categories = _computed$value.categories,
    searchCategory = _computed$value.search;
  var currentCategory = computed(function () {
    var _categories$value;
    return (_categories$value = categories.value) === null || _categories$value === void 0 ? void 0 : _categories$value.find(function (category) {
      return category.id === categoryId.value;
    });
  });
  var slug = computed(function () {
    var _currentCategory$valu;
    switch (contentType) {
      case 'PageProductListingPage':
        return (_currentCategory$valu = currentCategory.value) === null || _currentCategory$valu === void 0 ? void 0 : _currentCategory$valu.slug;
      default:
        return internalLinkObj === null || internalLinkObj === void 0 ? void 0 : internalLinkObj.slug;
    }
  });
  var internalLinkLocale = (internalLinkObj === null || internalLinkObj === void 0 ? void 0 : (_internalLinkObj$sys = internalLinkObj.sys) === null || _internalLinkObj$sys === void 0 ? void 0 : _internalLinkObj$sys.locale) || currentLocale.value;
  var internalLink = computed(function () {
    var linkArray = [];
    if (!isDefaultLocale()) {
      linkArray.push(internalLinkLocale);
    }
    var pagePrefix = getGraphqlPagePrefix(contentType, currentLocale.value);
    if (pagePrefix) {
      linkArray.push(pagePrefix);
    }
    if (!slug.value && !PAGES_WITH_NO_SLUG.includes(contentType)) {
      // page should have a slug, url can't be built
      return null;
    }
    if (slug.value) {
      linkArray.push(slug.value);
    }
    if (linkArray.length > 0) {
      return "/".concat(linkArray.join('/'));
    }
    return null;
  });
  var shouldFetchCategory = computed(function () {
    var _categories$value2;
    return ((_categories$value2 = categories.value) === null || _categories$value2 === void 0 ? void 0 : _categories$value2.length) === 0;
  });
  useLazyAsyncData('composable-useInternalLinkGraphQL', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!shouldFetchCategory.value) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return searchCategory({
            catIds: [categoryId.value]
          });
        case 3:
          return _context.abrupt("return", true);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  watch(categoryId, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(newCategoryId) {
      var _categories$value3;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(newCategoryId && ((_categories$value3 = categories.value) === null || _categories$value3 === void 0 ? void 0 : _categories$value3.length) === 0)) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return searchCategory({
              catIds: [newCategoryId]
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    immediate: true
  });
  return {
    internalLink: internalLink
  };
}